import { render, staticRenderFns } from "./success-forgot-user-password-modal.vue?vue&type=template&id=9ea658aa&"
import script from "./success-forgot-user-password-modal.vue?vue&type=script&lang=js&"
export * from "./success-forgot-user-password-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports